// ---------------------------------------------------------------------------
// Task event type constants
// ---------------------------------------------------------------------------

export const TaskEventType = {
  ScheduledRunSkipped: "task.scheduled_run_skipped",
  ScheduledRunStarted: "task.scheduled_run_started",
  ScheduleUpdated: "task.schedule_updated",
  Created: "task.created",
  Updated: "task.updated",
  Deleted: "task.deleted",
  CommentAdded: "task.comment_added",
  AssigneeChanged: "task.assignee_changed",
  ParentChanged: "task.parent_changed",
  StatusUpdated: "task.status_updated",
  Blocked: "task.blocked",
  Completed: "task.completed",
  ParticipantMentioned: "task.participant_mentioned",
  ParticipantRemoved: "task.participant_removed",
  ExecutionCreated: "task.execution_created",
  ExecutionCanceled: "task.execution_canceled",
  ExecutionSuperseded: "task.execution_superseded",
  ExecutionCompleted: "task.execution_completed",
  ExecutionFailed: "task.execution_failed",
  ExecutionActionRecorded: "task.execution_action_recorded",
  LinkedResourceAdded: "task.linked_resource_added",
  LinkedResourceRemoved: "task.linked_resource_removed",
  WatcherAdded: "task.watcher_added",
  WatcherRemoved: "task.watcher_removed",
} as const;

export type TaskEventType = (typeof TaskEventType)[keyof typeof TaskEventType];

// ---------------------------------------------------------------------------
// Event types hidden from the activity feed.
// Comments are already rendered inline — showing a separate "comment added"
// event is redundant.
// ---------------------------------------------------------------------------

export const HIDDEN_FEED_EVENT_TYPES: ReadonlySet<string> = new Set<TaskEventType>([
  TaskEventType.CommentAdded,
  TaskEventType.ParticipantMentioned,
  TaskEventType.ExecutionCreated,
  TaskEventType.WatcherAdded,
  TaskEventType.WatcherRemoved,
]);
